import gql from 'graphql-tag';
import { basicMemberFields } from './GetMember';
import { storeBasicFields } from './GetStore';

const key = `UpdateMember`;
const mutation = gql`
mutation ${key}($input:UpdateMemberInput!) {
  updateMember(input: $input) {
    ${basicMemberFields}
    store {
      ${storeBasicFields}
    }
    role {
      id
    }
    manager {
      ${basicMemberFields}
    }
  }
}
`;

export const UPDATE_MEMBER = { key, mutation };
